import whoAmI from './whoami';
import workgroups from './workgroups';

export default { whoAmI, workgroups };
